export default __webpack_public_path__ + "ebf381f4b37fdc8407dd31387e1d07c4.svg";